<div class="form-wrapper">
  <h2 class="form-title">{{ 'register.title' | translate }}</h2>
  <p class="form-subtitle">{{ 'login-page.register.subtitle' | translate }}</p>


  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

    <!-- Nome completo -->
    <div class="field-group">
      <label class="field-label">{{ 'register.title-name' | translate }}</label>
      <mat-form-field appearance="outline" class="login-field full-width">
        <input matInput type="text" formControlName="name" autocomplete="name" />
        @if (form.get('name')?.hasError('required') && form.get('name')?.touched) {
          <mat-error>{{ 'login-page.register.name-required' | translate }}</mat-error>
        } @else if (form.get('name')?.hasError('minlength') && form.get('name')?.touched) {
          <mat-error>{{ 'login-page.register.name-minlength' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- E-mail -->
    <div class="field-group">
      <label class="field-label">{{ 'forgot.title-mail' | translate }}</label>
      <mat-form-field appearance="outline" class="login-field full-width">
        <input
          matInput
          type="email"
          formControlName="email"
          placeholder="seu@email.com"
          autocomplete="email"
        />
        @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
          <mat-error>{{ 'global.validate.mail-required' | translate }}</mat-error>
        } @else if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
          <mat-error>{{ 'global.validate.mail-error' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Senha -->
    <div class="field-group">
      <label class="field-label">{{ 'register.title-password' | translate }}</label>
      <mat-form-field appearance="outline" class="login-field full-width">
        <input
          matInput
          [type]="isPasswordVisible ? 'text' : 'password'"
          formControlName="password"
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="togglePassword()"
          [attr.aria-label]="(isPasswordVisible ? 'login-page.register.hide-password' : 'login-page.register.show-password') | translate"
        >
          <mat-icon>{{ isPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
          <mat-error>{{ 'global.validate.password-required' | translate }}</mat-error>
        } @else if (form.get('password')?.hasError('minlength') && form.get('password')?.touched) {
          <mat-error>{{ 'login-page.register.password-minlength' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Confirmar senha -->
    <div class="field-group">
      <label class="field-label">{{ 'login-page.register.confirm-label' | translate }}</label>
      <mat-form-field appearance="outline" class="login-field full-width">
        <input
          matInput
          [type]="isConfirmPasswordVisible ? 'text' : 'password'"
          formControlName="confirmPassword"
          autocomplete="new-password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="toggleConfirmPassword()"
          [attr.aria-label]="(isConfirmPasswordVisible ? 'login-page.register.hide-password' : 'login-page.register.show-password') | translate"
        >
          <mat-icon>{{ isConfirmPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (form.get('confirmPassword')?.hasError('required') && form.get('confirmPassword')?.touched) {
          <mat-error>{{ 'login-page.register.confirm-required' | translate }}</mat-error>
        } @else if (form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched) {
          <mat-error>{{ 'login-page.register.passwords-mismatch' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="terms-field">
      <input
        id="termsAccepted"
        type="checkbox"
        class="terms-checkbox"
        formControlName="termsAccepted"
      />
      <label class="terms-label" for="termsAccepted">
        {{ 'login-page.register.terms-prefix' | translate }}
        <a
          class="terms-link"
          href="https://app.isofarm.com.br/#/termos-uso"
          target="_blank"
          rel="noopener noreferrer"
          (click)="$event.stopPropagation()"
        >
          {{ 'login-page.register.terms-link' | translate }}
        </a>
      </label>
    </div>

    <button
      mat-flat-button
      type="submit"
      class="submit-btn full-width"
      [disabled]="form.invalid || isLoading"
    >
      @if (isLoading) {
        <mat-spinner diameter="20" />
      } @else {
        {{ 'login-page.register.submit' | translate }}
      }
    </button>

  </form>

  <div class="card-footer">
    <p class="footer-link-text">
      {{ 'login-page.register.already-have-account' | translate }}
      <button type="button" class="link-btn" (click)="changeView.emit('login')">
        {{ 'login-page.register.login-link' | translate }}
      </button>
    </p>
  </div>
</div>
